// extracted by mini-css-extract-plugin
export default {"tableContainer":"AdminRequestTable_tableContainer__oybS7","customTableWrapper":"AdminRequestTable_customTableWrapper__clGBo","header":"AdminRequestTable_header__FLUAz"};